export class DebugGraphics extends Phaser.GameObjects.Container {

    public static currentInstance: DebugGraphics;

    private graphics: Phaser.GameObjects.Graphics;
    private dynamicGraphics: Phaser.GameObjects.Graphics;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        DebugGraphics.currentInstance = this;

        this.graphics = new Phaser.GameObjects.Graphics(this.scene);
        this.add(this.graphics);
        
        this.dynamicGraphics = new Phaser.GameObjects.Graphics(this.scene);
        this.add(this.dynamicGraphics);
    }

    public clearDynamicGraphics(): void {

        this.dynamicGraphics.clear();
    }

    public clear(): void {

        this.graphics.clear();
    }

    public drawCircle(x: number, y: number, radius: number, color: number, thickness?: number, dynamic?: boolean): void {
        
        if (dynamic) {
            this.dynamicGraphics.lineStyle(thickness || 2, color);
            this.dynamicGraphics.strokeCircle(x, y, radius);
        } else {
            this.graphics.lineStyle(thickness || 2, color);
            this.graphics.strokeCircle(x, y, radius);
        } 
    }

    public drawPoint(x: number, y: number, color: number, dynamic?: boolean): void {

        if (dynamic) {
            this.dynamicGraphics.fillStyle(color, 1);
            this.dynamicGraphics.fillPoint(x, y, 6);
        } else {
            this.graphics.fillStyle(color, 1);
            this.graphics.fillPoint(x, y, 16);
        } 
    }

    public drawLine(x1: number, y1: number, x2: number, y2: number, color: number, thickness?: number): void {
            
        this.graphics.lineStyle(thickness || 2, color);
        this.graphics.lineBetween(x1, y1, x2, y2);
    }
}
